import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { PerguntaFrequenteInputDto } from '../domain/DTOs/input/perguntas-frequentes.input.dto';
import { PerguntaFrequenteOutputDto } from '../domain/DTOs/output/pergunta-frequente.output.dto';
import { EstruturaRetornoDadosOutputDto } from '../domain/DTOs/output/estrutura-retorno-dados.output.dto';

@Injectable()
export class PerguntasFrequentesService {

  constructor(private baseService: BaseService) {}

  public listarPerguntasFrequentes(
    perguntaFrequenteInputDto: PerguntaFrequenteInputDto
  ): Observable<EstruturaRetornoDadosOutputDto<PerguntaFrequenteOutputDto[]>> {
    return this.baseService.get(`PerguntasFrequentes/ListarPerguntasFrequentes?TextoPesquisa=${perguntaFrequenteInputDto.TextoPesquisa}`);
  }
}
